module.exports = __webpack_public_path__ + "static/media/webstorm.549d8daa.png";